import { createAsyncReducer } from '../../standard-actions/';
import {
    IServiceRequestAddCommentAction,
    IServiceRequestAddCommentsNotStartedAction,
    IServiceRequestAddCommentsSuccessAction,
    IServiceRequestAddCommentsErrorAction
} from '../actions/add-comment-request';
import { IServiceRequestsState } from '../state';
import { initialState } from '@telstra-connect/service-requests/state/initial-state';

export type PostRequestCommentAction
    = IServiceRequestAddCommentAction
    | IServiceRequestAddCommentsNotStartedAction
    | IServiceRequestAddCommentsSuccessAction
    | IServiceRequestAddCommentsErrorAction;

const init = (state: IServiceRequestsState, action: PostRequestCommentAction) => ({
    ...state,
    [`addComment-${action.ritm}`]: {
        ...initialState.addComment,
        status: action.status
    }
});

const notStarted = (state: IServiceRequestsState, action: PostRequestCommentAction) => {
    return {
        ...state,
        [`addComment-${action.ritm}`]: {
            ...initialState.addComment,
            status: action.status
        }
    };
};

const success = (state: IServiceRequestsState, action: PostRequestCommentAction) => {
    return {
        ...state,
        [`addComment-${action.ritm}`]: {
            ...initialState.addComment,
            status: action.status
        }
    };
};

const failure = (state: IServiceRequestsState, action: PostRequestCommentAction) => ({
    ...state,
    [`addComment-${action.ritm}`]: {
        ...initialState.addComment,
        status: action.status,
        error: (action as IServiceRequestAddCommentsErrorAction).error
    }
});

export const postRequestCommentReducer = createAsyncReducer(initialState, init, notStarted, success, failure);
